import classNames from 'classnames';
import { FC } from 'react';

import { EventItem, getEventSeatAvailability, isPastEventEnd } from '@/entities/event';
import { Sticker } from '@/shared/ui';

import styles from './eventHero.module.scss';

interface EventHeroProps {
  event: EventItem;
}

const EventHero: FC<EventHeroProps> = ({ event }) => {
  const registrationClosed = isPastEventEnd(event.end_at);
  const { noSeatsLeft, totalSeats, shouldShowLimitedSeatsSticker } =
    getEventSeatAvailability(event);

  return (
    <section className={styles.hero}>
      <div
        aria-label={event.title}
        className={styles.hero__image}
        role="img"
        style={
          event.image
            ? { backgroundImage: `url("${event.image.replace(/"/g, '\\"')}")` }
            : undefined
        }
      />

      <div className={classNames('container', styles.hero__content)}>
        {registrationClosed ? (
          <Sticker className={styles.hero__sticker} variant="red">
            Запись закрыта
          </Sticker>
        ) : noSeatsLeft ? (
          <Sticker className={styles.hero__sticker} variant="red">
            Нет доступных мест
          </Sticker>
        ) : shouldShowLimitedSeatsSticker ? (
          <Sticker className={styles.hero__sticker} variant="white">
            Осталось {event.available_seats} из {totalSeats ?? '?'} мест
          </Sticker>
        ) : null}
        <div className={styles.hero__title_block}>
          <h1 className={styles.hero__title}>{event.title}</h1>
        </div>
      </div>
    </section>
  );
};

export default EventHero;
